import React from "react";
import "./style.css";
import {QuestionnaireMultiple} from "../../../../components/QuestionnaireMultiple";
import {ALLERGY} from "../../../../const/WeightLossQuestionnaire";

export const FoodRestrictions = (props) => {
  const list = {
    title: "Do you have any food restrictions?",
    list: [{value:"No allergies", isNone: true},
        ...ALLERGY]
  };

  return (
    <div className="gallery-page">
      <QuestionnaireMultiple {...props} list={list} />
    </div>
  );
};
